module.exports = __webpack_public_path__ + "static/media/dots-loading.1af813b0.gif";